module.exports = __webpack_public_path__ + "img/search2.e058f74c.jpg";